module.exports = __webpack_public_path__ + "img/front_page_report.ddc095d2.svg";